exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CircularProgressbar-path {\r\n    stroke: #428adf !important;\r\n}\r\n.CircularProgressbar-trail {\r\n    stroke: #eee !important;\r\n}", ""]);

